<template>
  <div>
    <div class="init-icons">
      <v-icon class="init-icon no-select">
        support_agent
      </v-icon>
      <img src="@/assets/img/arrow-transf.svg" class="img-responsive-logo no-select"/>
      <img class="img-responsive-logo no-select" :src="`https://files.colektia.com/company_logos/${$auth.user().company_id}.png`" alt="Colektia">
    </div>
    <div v-if="!campaignTransfer">
      <p class="text-font mt-5">Estas siendo conectado a <b>{{ campaignName }}</b></p>
    </div>
    <div v-else>
      <p v-if="campaignName" class="text-font mt-4">Seras reconectado a <b>{{ campaignName }}</b></p>
      <p v-else class="text-font mt-4" style="height: 27px;"></p>
      <v-btn  
      :disabled="disableTransferButton"
      class="k-orange-linear white--text mt-5" block large
      @click="$emit('transfer-now')">
        Conectar ahora ({{ countdown }} segs)
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaignTransfer: {
      type: Boolean,
      default: false,
    },
    campaignName: {
      type: String,
      default: '',
    },
    disableTransferButton: {
      type: Boolean,
      default: false,
    },
    countdown: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
.init-icon { 
  font-size: 65px;
  color: #2e2e44;
}

.init-icons {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: space-around;
}
.img-responsive-logo {
  width: auto;
  height: auto;
  max-height: 65px;
  margin-top: 0px;
}

.text-font { 
  text-align: center; 
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/ConnectionStages/Connecting.vue